export default __webpack_public_path__ + "static/media/woodlab-construction.94a9f56a.wav";